import { inject, Injectable } from "@angular/core";
import { defaults } from "../../../../desktop/src/app/app.config";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "./api.service";
import { Router } from "@angular/router";
import { StorageService } from "./storage.service";

@Injectable({ providedIn: "root" })
export class CoreService {
  apiService = inject(ApiService);
  featureFlags: Record<string, boolean> = {};
  router = inject(Router);
  storage = inject(StorageService);

  constructor(private http: HttpClient) {}

  getOptions() {
    return this.options;
  }

  private options = defaults;

  getLocale() {
    // const locale = sessionStorage.getItem("locale");
    const locale = this.storage.getItem<string>("locale");

    if (locale !== null) {
      return locale;
    }

    return "en";
  }

  changePassword(body: any) {
    return this.http.post(`${environment.sURL}${environment.endpoints.changePassword}`, body);
  }

  updateLanguage(body: any) {
    return this.http.post(`${environment.sURL}${environment.endpoints.updateLanguage}`, body);
  }

  withdrawFunds(body: any) {
    return this.http.post(`${environment.sURL}${environment.endpoints.withdrawFunds}`, body);
  }

  fetchCurrency() {
    return this.http.get(`${environment.sURL}${environment.endpoints.currency}`);
  }

  fetchMaintenanceStatus(domain: string) {
    return this.http.get(`${environment.sURL}${environment.endpoints.maintenanceStatus}/${domain}`);
  }

  setMaintenanceMode(param: string) {
    // sessionStorage.setItem("maintenanceMode", param);
    this.storage.setItem("maintenanceMode", param);
  }

  redirectToMaintenance = () => {
    this.setMaintenanceMode("YES");
    this.router.navigate(["/maintenance"]);
  };

  get isDevOrUat() {
    return /(dev-|uat-)/.test(environment.sURL);
  }
}
